import { ApolloProvider } from '@apollo/client';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { clientOptions } from './data/hasuraConfig';
import './index.css';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <React.StrictMode>
    <ApolloProvider client={clientOptions}>
      <App />
    </ApolloProvider>
  </React.StrictMode>
);
reportWebVitals();
